//SWEETALERT2
import Swal from "sweetalert2/dist/sweetalert2.js"
//REACT-TOASTIFY
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { unverified, verified } from "../images/other"
import "../styles/toastModal.css"
import { CheckCircle } from "lucide-react"

export const successAlert = (message: string) => {
    Swal.fire({
        iconHtml: `<img src=${verified}>`,
        title: message ? "" : "Success",
        showConfirmButton: false,
        html: `
          <div class="text-white mb-4">${message}</div>
          <button id="custom-ok-btn" 
            class="bg-[#ff8c3f] hover:bg-[#ff7a20] text-white px-4 py-2 rounded-lg mt-4">
            OK
          </button>
        `,
        customClass: {
            popup: "swal-popup-border",
        },
        didRender: () => {
            const btn = document.getElementById("custom-ok-btn")
            if (btn) {
                btn.addEventListener("click", () => Swal.close())
            }
        },
    })
}

export const errorAlert = (message: string) => {
    Swal.fire({
        title: message ? "" : "Error",
        iconHtml: `<img src=${unverified}>`,
        showConfirmButton: false,
        confirmButtonColor: "#ff8c3f",
        html: `
          <div class="text-white mb-4">${message}</div>
          <button id="custom-ok-btn" 
            class="bg-[#ff8c3f] hover:bg-[#ff7a20] text-white px-4 py-2 rounded-lg mt-4">
            OK
          </button>
        `,
        didRender: () => {
            const btn = document.getElementById("custom-ok-btn")
            if (btn) {
                btn.addEventListener("click", () => Swal.close())
            }
        },
        customClass: {
            popup: "swal-popup-border",
        },
    })
}

export const successNotify = (message: string) => toast.success(message)
export const errorNotify = (message: string) => toast.error(message)
export const infoNotify = (message: string) => toast.info(message)
